import CreateAssociationInformationFields from './CreateAssociationInformationFields.component';

export default CreateAssociationInformationFields;